// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody } from '@components/card/card.jsx';
import AddPosition from './AddPosition.jsx';
// import Pagination from '@components/Shared/Pagination/Pagination.jsx';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getPositions } from '@store/HR/HRSetting/positionSlice.js';
import ModalComponent from '@components/Modal/ModalComponent.jsx';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import Breadcrumb from '@components/Shared/Breadcrumb';
import Loading from '@components/Shared/Loader/Loading';
import NtxTable from '@components/DataTable/NtxTable.jsx';
import EditPosition from './EditPosition';

// const Position = () => {
//   const { HasPermission } = usePermissions();
//   const [id, setId] = useState('');

//   const [Show, setShow] = useState(false);
//   const { t, i18n } = useTranslation();

//   const { Positions, loading, error } = useSelector(state => state.Positions);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     if (Positions?.length === 0) {
//       dispatch(getPositions());
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const columns = [
//     { title: t('Name'), key: 'Name' },
//     { title: t('Job'), key: 'Job' },
//     { title: t('Organization'), key: 'org' },
//     { title: t('location'), key: 'location' },
//     { title: t('Vacancy'), key: 'headcount', className: 'text-theme fw-bold fs-5' },
//     { title: t(''), key: 'action', className: 'text-end' }
//   ];

//   const tableData = Positions?.map(item => {
//     let rowClass;

//     return {
//       Name: i18n.language === 'en' ? item.name : item.name2,
//       Job: i18n.language === 'ar' ? item.jobName : item.jobName2,
//       org: i18n.language === 'en' ? item.organizationName : item.organizationName2,
//       location: i18n.language === 'en' ? item.locationName : item.locationName2,
//       headcount: item.headcount,
//       action: (
//         <>
//           {HasPermission('ViewDetailsHrPerPosition') && (
//             <button
//               type='button'
//               className='btn btn-sm btn-outline-theme'
//               data-bs-toggle='modal'
//               data-bs-target='#Update'
//               onClick={() => setId(item.id)}
//             >
//               <i className='far fa-lg fa-fw me-2 fa-edit'></i>
//               {t('ViewDetails')}
//             </button>
//           )}
//         </>
//       ),

//       rowClass // استخدم rowClass هنا
//     };
//   });

//   var BcrumbList = [
//     {
//       name: 'Home',
//       link: ':moduleHome'
//     },
//     {
//       name: t('Positions'),
//       link: null
//     }
//   ];

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Positions')} />
//         {HasPermission('AddHrPerPosition') && (
//           <div className='ms-auto'>
//             <Link
//               to=''
//               className='btn me-1 btn-theme'
//               data-bs-toggle='modal'
//               data-bs-target='#modalAddPosition'
//               onClick={() => setShow(true)}
//             >
//               <i className='fa fa-plus-circle fa-fw me-1'></i>
//               {t('AddPosition')}
//             </Link>
//           </div>
//         )}
//       </div>

//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <NtxTable
//               data={tableData || []}
//               columns={columns}
//               dataPerPage={10}
//               theadClass=''
//               tableClass='table text-nowrap table-hover '
//               enableSearch
//               showRecordsSelector
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <ModalComponent title={t('AddPosition')} id='modalAddPosition' size='lg'>
//         {Show && <AddPosition />}
//       </ModalComponent>

//       <ModalComponent id='Update' title={t('EditPosition')} size='lg'>
//         {id && <EditPosition id={id} />}
//       </ModalComponent>
//     </>
//   );
// };

const Position = () => {
  const { HasPermission } = usePermissions();
  const [id, setId] = useState('');

  const [Show, setShow] = useState(false);
  const { t, i18n } = useTranslation();

  const { Positions, loading, error } = useSelector(state => state.Positions);
  const dispatch = useDispatch();
  useEffect(() => {
    if (Positions?.length === 0) {
      dispatch(getPositions());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { title: t('Code'), key: 'Code' }, // Added
    { title: t('Name'), key: 'Name' },
    { title: t('Job'), key: 'Job' },
    { title: t('Organization'), key: 'org' },
    { title: t('location'), key: 'location' },
    { title: t('Vacancy'), key: 'headcount', className: 'text-theme fw-bold fs-5' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = Positions?.map(item => {
    let rowClass;

    return {
      Code: item.code, // Added
      Name: i18n.language === 'en' ? item.name : item.name2,
      Job: i18n.language === 'ar' ? item.jobName : item.jobName2,
      org: i18n.language === 'en' ? item.organizationName : item.organizationName2,
      location: i18n.language === 'en' ? item.locationName : item.locationName2,
      headcount: item.headcount,
      action: (
        <>
          {HasPermission('ViewDetailsHrPerPosition') && (
            <button
              type='button'
              className='btn btn-sm btn-outline-theme'
              data-bs-toggle='modal'
              data-bs-target='#Update'
              onClick={() => setId(item.id)}
            >
              <i className='far fa-lg fa-fw me-2 fa-edit'></i>
              {t('ViewDetails')}
            </button>
          )}
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: t('Positions'),
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Positions')} />
        {HasPermission('AddHrPerPosition') && (
          <div className='ms-auto'>
            <Link
              to=''
              className='btn me-1 btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalAddPosition'
              onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('AddPosition')}
            </Link>
          </div>
        )}
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddPosition')} id='modalAddPosition' size='lg'>
        {Show && <AddPosition />}
      </ModalComponent>

      <ModalComponent id='Update' title={t('EditPosition')} size='lg'>
        {id && <EditPosition id={id} />}
      </ModalComponent>
    </>
  );
};

export default Position;
